import { Component } from '@angular/core'

@Component({
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
})
export class AuthComponent {
  title = 'app-consumer'
}
